import React, { useState } from "react";
import { Dialog, Tag, FormGroup, Classes, Button, H4 } from "@blueprintjs/core";
import { Trans } from 'react-i18next';

import { authenticatedPutFetch } from "../../utils/AuthenticatedFetch";
import { EquipmentSelect } from "../Structure/EquipmentSelector";

export default function CustomEndpoint(props) {
    const [AddTerminal, setAddTerminal] = useState(false);
    const [CompleteAdd, setCompleteAdd] = useState(true);
    const [AssociatedEquipment, setAssociatedEquipment] = useState(undefined);
    const [AssociatedEquipmentSelection, setAssociatedEquipmentSelection] = useState(undefined);

    return <div>
        <Tag
            large={true}
            round={true}
            icon="manually-entered-data"
            interactive={true}
            onClick={() => {
                setAddTerminal(true);
                if (props.equipment !== undefined && props.equipment_name !== undefined)
                    setAssociatedEquipmentSelection(props.equipment_name)
            }} />
        <Dialog
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            icon="manually-entered-data"
            isOpen={AddTerminal}
            isCloseButtonShown={true}
            onClose={() => {
                setAddTerminal(false);
                setCompleteAdd(true);
                setAssociatedEquipment(undefined);
            }}
            title={<Trans>edit terminal</Trans>}>
            <div className={Classes.DIALOG_BODY} >
                {(props.type !== undefined) &&
                    <div className="flexbox-center">
                        < H4><Trans>{props.type}</Trans></ H4>
                    </div>}
                <div className="flexbox-center">
                    <FormGroup label={<Trans>associated equipment</Trans>} labelFor="AssociatedEquipment-input" >
                        <EquipmentSelect
                            onSelect={(id, park, server, pk) => setAssociatedEquipment(pk)}
                            selection={AssociatedEquipmentSelection}
                        />
                    </FormGroup>
                </div>
            </div>
            <div className="flexbox-center">
                <FormGroup>
                    <Button
                        intent="primary"
                        onClick={() => {
                            if (AssociatedEquipment === undefined) {
                                setCompleteAdd(false)
                            }
                            else {
                                setCompleteAdd(true);
                                authenticatedPutFetch("/phonie/endpoint",
                                    { remove_name: props.channel, name: props.name, equipment: AssociatedEquipment },
                                    () => setAddTerminal(false));
                                setAssociatedEquipment(undefined);
                                props.onDelete();
                            }
                        }}>
                        <Trans>edit</Trans>
                    </Button>
                </FormGroup>
            </div>
            {(!CompleteAdd) &&
                <Tag
                    large={true}
                    intent="warning"
                    icon="warning-sign">
                    <Trans>please fill in the fields above before validating</Trans></Tag>}
        </Dialog>
    </div >
}